module.exports = __webpack_public_path__ + "static/cercazone_nordest2-ea48575aa93e72912eb2f7292bde774b.jpg";